import { useEffect, useState, useRef } from "react";
import Hero from "./Mobile/Hero";
import AboutUs from "./Mobile/AboutUs";
import ContactUs from "./Mobile/ContactUs";
import Products from "./Mobile/Products";
import Services from "./Mobile/Services";
import Partners from "./Mobile/Partners";
import Navbar from "./Mobile/Navbar";

const Landing = () => {
  const [activeSection, setActiveSection] = useState(0);
  const sectionsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = sectionsRef.current.indexOf(entry.target);
            if (index !== -1) {
              setActiveSection(index);
            }
          }
        });
      },
      {
        threshold: 0.5,
        rootMargin: "-10% 0px -10% 0px",
      }
    );

    sectionsRef.current.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => {
      sectionsRef.current.forEach((section) => {
        if (section) observer.unobserve(section);
      });
    };
  }, []);

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  return (
    <div className="relative">
      {/* مؤشر التقدم */}
      <Navbar />

      {/* خلفية ديناميكية */}
      <div
        className="fixed inset-0 -z-10 transition-all duration-1000 ease-in-out"
        style={{
          background: getBackgroundBySection(activeSection),
        }}
      />
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-cyan-900  py-5 relative overflow-hidden">
        <div ref={addToRefs}>
          <Hero />
        </div>
        <div ref={addToRefs}>
          <AboutUs />
        </div>
        <div ref={addToRefs}>
          <Products />
        </div>
        <div ref={addToRefs}>
          <Services />
        </div>
        <div ref={addToRefs}>
          <Partners />
        </div>
        <div ref={addToRefs}>
          <ContactUs />
        </div>
      </div>
    </div>
  );
};

// دالة لتعيين الخلفية حسب القسم النشط
const getBackgroundBySection = (sectionIndex) => {
  const gradients = [
    "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)", // Hero
    "linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%)", // AboutUs
    "linear-gradient(135deg, #0f172a 0%, #1e40af 50%, #0f172a 100%)", // Products
    "linear-gradient(135deg, #1e293b 0%, #7e22ce 50%, #1e293b 100%)", // Services
    "linear-gradient(135deg, #0f172a 0%, #059669 50%, #0f172a 100%)", // Partners
    "linear-gradient(135deg, #1e293b 0%, #dc2626 50%, #1e293b 100%)", // ContactUs
  ];

  return gradients[sectionIndex] || gradients[0];
};

export default Landing;
